import _toConsumableArray from "/app/web/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _asyncToGenerator from "/app/web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "/app/web/node_modules/@babel/runtime/regenerator";
import { PlusOutlined, UnorderedListOutlined } from '@ant-design/icons';
import { Button, DatePicker, Divider, Form, message, Modal, Space } from 'antd';
import { getAuthStore } from 'core/modules/auth/auth.store';
import { getPreferencesStore } from 'core/modules/preferences/preferences.store';
import { getRouteStore } from 'core/modules/routes/route.store';
import { getRoutePaginationStore } from 'core/modules/routes/ruotes-pagination.store';
import { getTaskStore } from 'core/modules/tasks/task.store';
import moment from 'moment';
import { useRouter } from 'next/router';
import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { UserSelect } from '../Form/UserSelect';
import { MileageRateSelect } from '../Rates/Form/MileageRateSelect';
import { RoutesTasksUpdateTasksModalNewTasksTable } from './Tasks/UpdateTasksModal/NewTasksTable';
import { RoutesUpdateTasksModalTasksList } from './Tasks/UpdateTasksModal/TasksList';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export var CreateRouteModal = function CreateRouteModal(_ref) {
  var isOpen = _ref.isOpen,
      initialTaskIds = _ref.initialTaskIds,
      onClose = _ref.onClose;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _getRouteStore = getRouteStore(),
      isLoading = _getRouteStore.isLoading,
      createRoute = _getRouteStore.createRoute;

  var _getTaskStore = getTaskStore(),
      tasksByIds = _getTaskStore.tasksByIds,
      populateTask = _getTaskStore.populateTask;

  var router = useRouter();

  var _getAuthStore = getAuthStore(),
      user = _getAuthStore.user,
      canManageRoutes = _getAuthStore.canManageRoutes;

  var _getRoutePaginationSt = getRoutePaginationStore(),
      addIds = _getRoutePaginationSt.addIds;

  var _getPreferencesStore = getPreferencesStore(),
      preferences = _getPreferencesStore.preferences;

  var _useState = useState(user === null || user === void 0 ? void 0 : user.id),
      assigneeId = _useState[0],
      setAssigneeId = _useState[1];

  var _useState2 = useState(new Date()),
      date = _useState2[0],
      setDate = _useState2[1];

  var _useState3 = useState(),
      rate = _useState3[0],
      setRate = _useState3[1];

  var _useState4 = useState(true),
      addingTasks = _useState4[0],
      setAddingTasks = _useState4[1];

  var _useState5 = useState([]),
      addSelectedIds = _useState5[0],
      setAddSelectedIds = _useState5[1];

  var _useState6 = useState([]),
      taskIds = _useState6[0],
      setTaskIds = _useState6[1];

  var _useState7 = useState(false),
      hasSelectedTasks = _useState7[0],
      setHasSelectedTasks = _useState7[1];

  var tasks = useMemo(function () {
    return tasksByIds(taskIds).map(populateTask);
  }, [tasksByIds, taskIds]);
  var needsToReassign = useMemo(function () {
    return tasksByIds(addSelectedIds).some(function (it) {
      return it.assignedToUserId !== assigneeId;
    });
  }, [assigneeId, addSelectedIds, tasksByIds]);
  var hasChanged = true;
  var canAccept = useMemo(function () {
    if (addingTasks) {
      return addSelectedIds.length > 0 && !needsToReassign;
    }

    return hasChanged && !!rate;
  }, [addingTasks, rate, addSelectedIds.length, needsToReassign, hasChanged]);
  var title = useMemo(function () {
    if (!hasSelectedTasks) {
      return /*#__PURE__*/_jsxs(Space, {
        children: [/*#__PURE__*/_jsx(UnorderedListOutlined, {}), t('route.create.selectTasks')]
      });
    }

    if (addingTasks) {
      return /*#__PURE__*/_jsxs(Space, {
        children: [/*#__PURE__*/_jsx(PlusOutlined, {}), t('route.create.addMore')]
      });
    }

    return /*#__PURE__*/_jsxs(Space, {
      children: [/*#__PURE__*/_jsx(PlusOutlined, {}), t('route.create.title')]
    });
  }, [addingTasks]);

  var onSubmit = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var route;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return createRoute({
                assignee: assigneeId,
                date: date.toISOString(),
                rate: rate,
                tasks: tasks.map(function (it) {
                  return it.id;
                })
              });

            case 3:
              route = _context.sent;
              onClose();
              addIds(route.id);
              router.push("/routes/".concat(route.id));
              message.success(t('changesSaved'));
              _context.next = 13;
              break;

            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](0);
              message.error(t('unknownError'));

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 10]]);
    }));

    return function onSubmit() {
      return _ref2.apply(this, arguments);
    };
  }();

  var onCancel = function onCancel() {
    if (isLoading) {
      return;
    }

    if (addingTasks) {
      if (hasSelectedTasks) {
        return setAddingTasks(false);
      }
    }

    onClose();
  };

  var onAccept = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!isLoading) {
                _context2.next = 2;
                break;
              }

              return _context2.abrupt("return");

            case 2:
              if (!addingTasks) {
                _context2.next = 9;
                break;
              }

              setTaskIds(function (items) {
                return [].concat(_toConsumableArray(items), _toConsumableArray(addSelectedIds));
              });
              setAddingTasks(false);
              setAddSelectedIds([]);
              setHasSelectedTasks(true);
              _context2.next = 12;
              break;

            case 9:
              _context2.next = 11;
              return onSubmit();

            case 11:
              return _context2.abrupt("return", _context2.sent);

            case 12:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function onAccept() {
      return _ref3.apply(this, arguments);
    };
  }();

  useEffect(function () {
    if (isOpen) {
      setAddSelectedIds(initialTaskIds !== null && initialTaskIds !== void 0 ? initialTaskIds : []);
    } else {
      setTaskIds([]);
      setAddingTasks(true);
      setHasSelectedTasks(false);
    }
  }, [initialTaskIds, isOpen]);
  return /*#__PURE__*/_jsxs(Container, {
    title: title,
    open: isOpen,
    destroyOnClose: true,
    width: addingTasks ? 840 : 600,
    onCancel: onCancel,
    onOk: onAccept,
    okButtonProps: {
      disabled: !canAccept,
      loading: isLoading
    },
    children: [/*#__PURE__*/_jsxs(Form, {
      layout: "vertical",
      children: [/*#__PURE__*/_jsx(Form.Item, {
        label: t('route.maps.expert'),
        colon: false,
        children: /*#__PURE__*/_jsx(UserSelect, {
          value: assigneeId,
          onChange: setAssigneeId,
          isReadonly: hasSelectedTasks || !canManageRoutes
        })
      }), /*#__PURE__*/_jsx(Form.Item, {
        label: t('form.route.rate.label'),
        rules: [{
          required: true,
          message: t('form.route.rate.error.required')
        }],
        children: /*#__PURE__*/_jsx(MileageRateSelect, {
          onlyActive: true,
          value: rate,
          defaultValue: preferences === null || preferences === void 0 ? void 0 : preferences.defaultMileageRate,
          placeholder: t('form.route.rate.placeholder'),
          onChange: setRate
        })
      }), /*#__PURE__*/_jsx(Form.Item, {
        label: t('form.route.date.label'),
        getValueProps: function getValueProps(date) {
          return {
            value: date ? moment(date) : null
          };
        },
        children: /*#__PURE__*/_jsx(DatePicker, {
          value: moment(date),
          onChange: function onChange(value) {
            return setDate(value.toDate());
          },
          placeholder: t('form.route.date.placeholder')
        })
      })]
    }), /*#__PURE__*/_jsx(Divider, {}), !addingTasks && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(RoutesUpdateTasksModalTasksList, {
        tasks: tasks,
        onTaskIdsChange: setTaskIds
      }), /*#__PURE__*/_jsx(Button, {
        type: "link",
        onClick: function onClick() {
          return setAddingTasks(true);
        },
        children: /*#__PURE__*/_jsxs(Space, {
          children: [/*#__PURE__*/_jsx(PlusOutlined, {}), t('route.tasks.rearrange.addMore')]
        })
      })]
    }), addingTasks && /*#__PURE__*/_jsx(RoutesTasksUpdateTasksModalNewTasksTable, {
      assigneeId: assigneeId,
      currentTasks: taskIds,
      selectedIds: addSelectedIds,
      initialIds: initialTaskIds,
      isValid: !needsToReassign,
      onChange: setAddSelectedIds
    })]
  });
}; // Styles

var Container = styled(Modal).withConfig({
  displayName: "CreateRouteModal__Container",
  componentId: "sc-n2bz87-0"
})([".ant-form{max-width:400px;}.ant-picker{width:100%;}"]);